<template>
  <div data-component-group="dialog" data-component="confirm">
    <dialog-base :content-class="contentClass" :is-on="isOn">
      <template v-slot:title>
        <span>
          <slot name="title">
            {{ text }}
          </slot>
        </span>
      </template>

      <template v-slot:content>
        <slot name="content" />
      </template>

      <template v-slot:actions>
        <v-btn variant="text" @click="onCancel">
          {{ cancelLabel }}
        </v-btn>

        <v-btn color="primary" :loading="isLoading" @click="onConfirm">
          {{ confirmLabel }}
        </v-btn>
      </template>
    </dialog-base>
  </div>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        required: true,
      },
      // TODO translate default props
      cancelLabel: {
        type: String,
        default() {
          return 'Cancel';
        },
      },
      confirmLabel: {
        type: String,
        default() {
          return 'Ok';
        },
      },
      contentClass: {
        type: String,
        default: 'dialog-confirm',
      },
      isOn: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function,
        required: true,
      },
      onConfirm: {
        type: Function,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../assets/styles/theme' as *;

.dialog-confirm > .modal__backdrop > .modal__content {
  width: 420px;
  max-width: 100%;
  margin: 0 auto;
  background: rgb(var(--v-theme-background));

  > .modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin: 0 auto;
    color: rgb(var(--v-theme-on-surface));
    background-color: rgb(var(--v-theme-surface));

    span {
      font-size: $text-size-lg;
      font-weight: 500;
    }
  }

  > .modal__footer {
    display: flex;
    justify-content: flex-end;
    padding: $spacing-sm;
    background-color: rgb(var(--v-theme-surface));

    .v-btn {
      margin: 0;

      &:last-child {
        margin: 0 0 0 $spacing-sm;
      }
    }
  }
}
</style>
